import {Component, Inject, OnInit} from '@angular/core';
import {ChipsModule} from "../../../../global/chips/chips/chips.module";
import {DesignSystemModule} from "../../../../design-system/design-system.module";
import {NgIf} from "@angular/common";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {EditGroupDialogData} from "../edit-group-dialog/edit-group-dialog.component";
import {
	FunctionalCapacitiesService,
	FunctionalCapacityGroupUpdateForm,
	FunctionalCapacityUpdateForm
} from "../../../../../services/back/functional-capacities.service";
import {CurrentTenantService} from "../../../../../services/front/current-tenant.service";

@Component({
  selector: 'app-edit-capacity-dialog',
    imports: [
        ChipsModule,
        DesignSystemModule,
        ReactiveFormsModule,
        TranslateModule
    ],
  templateUrl: './edit-capacity-dialog.component.html',
  styleUrl: './edit-capacity-dialog.component.scss'
})
export class EditCapacityDialogComponent implements OnInit{
	editFunctionalCapacityGroupForm: FormGroup = new FormGroup({
		name: new FormControl<string | null>(null, [Validators.required]),
	});

	tenantId: string;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: EditGroupDialogData,
		private dialogRef: MatDialogRef<EditCapacityDialogComponent>,
		private functionalCapacitiesService: FunctionalCapacitiesService,
		private currentTenantService: CurrentTenantService
	) {}

	ngOnInit(): void {
		this.currentTenantService.getCurrentTenant()
			.subscribe(tenant => this.tenantId = tenant.configuration.id);

		if (this.data) {
			this.editFunctionalCapacityGroupForm.patchValue({
				name: this.data.name || ''
			});
		}
	}

	onCancel(): void {
		this.dialogRef.close({ result: false, type: 'edit' });
	}

	onSave(): void {
		if (this.editFunctionalCapacityGroupForm.valid) {
			const form: FunctionalCapacityUpdateForm = {
				name: this.editFunctionalCapacityGroupForm.get('name')!.value,
			};

			this.functionalCapacitiesService.updateFunctionalCapacity(this.tenantId, this.data.id, form)
				.subscribe(result => {
					this.dialogRef.close({ result: result, type: 'edit' });
				});
		}
	}
}
